export class PlacardConfirmationSession {
    placardId: string = '';
    placardImage: UploadedImageInformation;
    placardDisplayed: boolean = false;
    pickupStartDate: string = '';
    customerFacingStartDate: string = '';
}
export class UploadedImageInformation {
    name: string = '';
    contents: string = '';
    extension: string = '';
    fullName: string = '';
}